import { useAppDispatch } from 'app/hooks';
import PageForm from 'components/forms/PageForm';
import Icon from 'components/icons/Icon';
import { IconSymbol } from 'components/icons/Icon.types';
import { useConfirmDelete } from 'components/modal/forms/ConfirmDeleteForm';
import { ModalDialogLink } from 'components/modal/Modal';
import { IMenu } from 'features/menu/menuAPI';
import { IPage } from 'features/page/pageAPI';
import { deletePageAsync } from 'features/page/pageSlice';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

type PageViewProps = {
  page: IPage;
};

export default function PageView(props: PageViewProps) {
  const { page } = props;
  const dispatch = useAppDispatch();
  const confirmDelete = useConfirmDelete();

  function handleRemovePage(page: IMenu) {
    function doDelete(): boolean {
      dispatch(
        deletePageAsync({
          id: page.id!,
        }),
      ).then((response: any) => {
        switch (response.payload?.response.status) {
          case 204:
            break;
          case 500:
          default:
            console.log(response);
        }
      });
      return true;
    }
    confirmDelete({
      prompts: {
        prompt1: (
          <FormattedMessage
            id="PAGES.DELETE_CONFIRM"
            values={{
              page: page.title,
            }}
          />
        ),
        prompt2: <FormattedMessage id="PAGES.DELETE_CONFIRM_2" />,
      },
      // again: { serious: true },
    }).then((confirmed: boolean) => {
      if (confirmed) doDelete();
    });
  }

  return (
    <div className="page_view">
      <h1>{page.title}</h1>&nbsp;—&nbsp;
      <Link to={`/${page.slug}`}>{page.slug}</Link>&nbsp;—&nbsp;{page.locale}
      &nbsp;—&nbsp;{page.author?.username}
      <ModalDialogLink
        className="icon_button"
        component={PageForm}
        componentProps={{ page: page }}
      >
        <Icon inline symbol={IconSymbol.pencil} size={14} />
      </ModalDialogLink>
      <Icon
        inline
        className="icon_button"
        symbol={IconSymbol.bin}
        size={14}
        onClick={() => handleRemovePage(page)}
      />
    </div>
  );
}
